// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/client/modules/app-settings/tabs/app-settings-cancellation/app-settings-cancellation.less
// module id = 3189
// module chunks = 0